/**
 * csrf token 获取说明：
 * 1. 有两个地方有：<meta name="csrf-token" content="xxx"> 和 cookie 的 XSRF-TOKEN
 * 2. token 包含盐，服务器拿到后 hash 完跟 session 中的 secret 比较，所以一个 csrf token 的过期跟 session 一起
 * 3. 从 cookie 获取 csrf token 是不稳定的，跟 sso id 的死循环事故原理差不多（读取不能指定 path，写能指定 path）
 */
import { getMetaValue } from "./metaConfig";

const canUseDOM = typeof document !== "undefined" && document !== null && !!document.createElement;

function getDefaultCSRFSetting() {
  return {
    param: "_csrf",
    header: "x-csrf-token",
  };
}

/**
 * @deprecated
 * @returns {String}
 */
export function getCSRFToken() {
  if (!canUseDOM) {
    return "";
  }

  return getMetaValue("csrf-token", "");
}

export function getCSRF() {
  const defaultCSRFSetting = getDefaultCSRFSetting();
  if (!canUseDOM) return defaultCSRFSetting;

  const settingFromMeta = {};
  const paramFromMeta = getMetaValue("csrf-param");
  if (paramFromMeta) settingFromMeta.param = paramFromMeta;
  const headerFromMeta = getMetaValue("csrf-header");
  if (headerFromMeta) settingFromMeta.header = headerFromMeta;

  return {
    ...defaultCSRFSetting,
    ...settingFromMeta,
    token: getMetaValue("csrf-token"),
  };
}
